import { CertificateStatusEnum } from "../../../common/enums/CertificateStatusEnum";

export const getRenewButtonText = (activeTab: string): string => {
    switch (activeTab) {
        case CertificateStatusEnum.EXPIRED:
            return "Opnieuw toevoegen";
        case CertificateStatusEnum.REJECTED:
            return "Certificaat bewerken";
        default:
            return "";
    }
};
